import { render, staticRenderFns } from "./ShortAnswerInput.vue?vue&type=template&id=99835a2a&scoped=true"
import script from "./ShortAnswerInput.vue?vue&type=script&lang=js"
export * from "./ShortAnswerInput.vue?vue&type=script&lang=js"
import style0 from "./ShortAnswerInput.vue?vue&type=style&index=0&id=99835a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99835a2a",
  null
  
)

export default component.exports